import { BaseService } from "./BaseService";
import type {
  ReviewAverageByCategoryResponse,
  ReviewDistributionResponse,
  ReviewOverallResponse,
  ReviewOverTimeResponse,
  ReviewSourceSplitResponse,
  ReviewsAnalyticsExportQuery,
  ReviewsAnalyticsRangeQuery,
} from "@/types/analytics-reviews";

class AnalyticsReviewsService extends BaseService {
  private readonly basePath = "/analytics/reviews";

  getOverall(
    query: ReviewsAnalyticsRangeQuery,
  ): Promise<ReviewOverallResponse> {
    return this.get<ReviewOverallResponse>(`${this.basePath}/overall`, query);
  }

  getDistribution(
    query: ReviewsAnalyticsRangeQuery,
  ): Promise<ReviewDistributionResponse> {
    return this.get<ReviewDistributionResponse>(
      `${this.basePath}/distribution`,
      query,
    );
  }

  getSourceSplit(
    query: ReviewsAnalyticsRangeQuery,
  ): Promise<ReviewSourceSplitResponse> {
    return this.get<ReviewSourceSplitResponse>(
      `${this.basePath}/source-split`,
      query,
    );
  }

  getAverageByCategory(
    query: ReviewsAnalyticsRangeQuery,
  ): Promise<ReviewAverageByCategoryResponse> {
    return this.get<ReviewAverageByCategoryResponse>(
      `${this.basePath}/average-by-category`,
      query,
    );
  }

  getOverTime(
    query: ReviewsAnalyticsRangeQuery,
  ): Promise<ReviewOverTimeResponse> {
    return this.get<ReviewOverTimeResponse>(
      `${this.basePath}/over-time`,
      query,
    );
  }

  exportReviews(query: ReviewsAnalyticsExportQuery): Promise<Blob> {
    return this.getBlob(`${this.basePath}/export`, query);
  }
}

export const analyticsReviewsService = new AnalyticsReviewsService();
